import {FiltersBody} from '@dms/api/core';

import {FiltersType} from '../types/FiltersType';

export const convertFiltersTypeToFiltersBody = (filters: FiltersType): FiltersBody => ({
  ...filters,
  address: filters.address ? filters.address : undefined,
  selectedColors: filters.selectedColors?.map((color) => ({
    key: color.key,
    name: color.label,
    colorCode: color.colorCode ?? '',
  })),
});
